import _cloneDeep from 'lodash/cloneDeep';

export const selectOrEmpty = (state, part, value = {}) => {
  const selection = state[part];

  if (selection === undefined) {
    return value;
  }
  return selection;
};

export const selectOrInit = (state, part, value = {}) => {
  const selection = state[part];
  if (selection === undefined) {
    // eslint-disable-next-line no-param-reassign
    state[part] = value;
    return state[part];
  }
  return selection;
};

export const cloneOrInitKey = (state, key) => {
  const slice = state[key];

  if (slice === undefined) {
    return {};
  }

  return _cloneDeep(slice);
};
